// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"05c7aef8","316":"6fc851ec","560":"edb22c68","750":"7b3b52f2","838":"8497160f"}[chunkId] + ".chunk.css";
};